import {useEffect, useState} from 'react';
import {whatsappUrl} from '~/utils';

export const WhatsappButton = ({
  className,
  invert,
  color,
  bgColor,
}: {
  className?: string;
  invert?: boolean;
  color?: string;
  bgColor?: string;
}) => (
  <a className={className} href={whatsappUrl}>
    <svg
      className="h-full w-full"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="80"
        height="80"
        rx="40"
        fill={bgColor ? bgColor : invert ? '#F7F4F1' : '#686144'}
      />
      <path
        d="M50.5144 29.3597C47.7069 26.5498 43.9732 25.0016 39.9952 25C31.7988 25 25.128 31.6683 25.1247 39.8648C25.1236 42.4848 25.8084 45.0423 27.1097 47.2966L25 55L32.8831 52.9328C35.0551 54.1171 37.5004 54.7412 39.9893 54.7422H39.9954C48.191 54.7422 54.8624 48.0731 54.8658 39.8766C54.8673 35.9045 53.322 32.1695 50.5144 29.3597ZM39.9954 52.2316H39.9903C37.7725 52.2307 35.5973 51.6351 33.6996 50.5093L33.2482 50.2416L28.5703 51.4683L29.819 46.9088L29.525 46.4414C28.2878 44.4741 27.6344 42.2003 27.6353 39.8657C27.638 33.0532 33.1826 27.5107 40.0002 27.5107C43.3014 27.512 46.4047 28.7989 48.7383 31.1343C51.0718 33.4698 52.3562 36.5742 52.355 39.8757C52.3523 46.6887 46.8078 52.2316 39.9954 52.2316ZM46.775 42.9777C46.4033 42.7918 44.5766 41.8932 44.236 41.7692C43.8954 41.6452 43.6478 41.5833 43.4 41.9552C43.1524 42.327 42.4403 43.1637 42.2235 43.4116C42.0067 43.6595 41.79 43.6905 41.4185 43.5045C41.0469 43.3186 39.8497 42.9264 38.4305 41.6609C37.3259 40.6761 36.5802 39.4596 36.3634 39.0877C36.1467 38.7159 36.3404 38.5149 36.5264 38.3297C36.6935 38.1633 36.8979 37.8958 37.0837 37.6789C37.2695 37.4621 37.3314 37.3071 37.4553 37.0592C37.5792 36.8113 37.5172 36.5943 37.4243 36.4084C37.3314 36.2225 36.5883 34.3942 36.2787 33.6505C35.9771 32.9262 35.6707 33.0242 35.4427 33.0128C35.2262 33.0021 34.9782 32.9998 34.7305 32.9998C34.4829 32.9998 34.0803 33.0927 33.7397 33.4646C33.3992 33.8365 32.4393 34.7351 32.4393 36.5634C32.4393 38.3916 33.7707 40.1579 33.9565 40.4058C34.1423 40.6537 36.5765 44.4056 40.3038 46.0145C41.1903 46.3972 41.8824 46.6257 42.422 46.7969C43.3121 47.0796 44.1221 47.0397 44.7624 46.9441C45.4762 46.8375 46.9606 46.0456 47.2703 45.1779C47.58 44.3102 47.58 43.5665 47.4871 43.4116C47.3942 43.2567 47.1465 43.1637 46.775 42.9777Z"
        fill={color ? color : invert ? '#686144' : '#F7F4F1'}
      />
    </svg>
  </a>
);

export const WhatsappPageButton = () => {
  const [isSubscriptionOrFooterHit, setIsSubscriptionOrFooterHit] =
    useState<boolean>(false);

  useEffect(() => {
    const scrollListener = () => {
      const subscriptionSection = document.getElementById(
        'subscription-section',
      );
      const footer = document.getElementById('footer-contactinfo');
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;
      let btnCloseToFooter = false;
      let btnCloseToSubscription = false;
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        btnCloseToFooter =
          footerRect.top + 100 >= 0 && footerRect.top + 100 < windowHeight;
      }
      if (subscriptionSection) {
        const rect = subscriptionSection.getBoundingClientRect();
        btnCloseToSubscription =
          rect.top + 100 >= 0 && rect.top + 100 < windowHeight;
      }
      setIsSubscriptionOrFooterHit(btnCloseToSubscription || btnCloseToFooter);
    };
    window.addEventListener('scroll', scrollListener);
    return () => {
      window.removeEventListener('scroll', scrollListener);
    };
  }, [setIsSubscriptionOrFooterHit]);

  return (
    <WhatsappButton
      className="md:right:12 fixed bottom-10 right-8 z-20 h-[60px] w-[60px] rounded-full sm:h-[80px] sm:w-[80px] md:bottom-12"
      invert={isSubscriptionOrFooterHit}
    />
  );
};
